import * as angular from 'angular';
import { debounceFactory } from './angular-debounce.service';

export const $debounceModule = angular.module('$debounceModule', [])
	.factory('$debounce', debounceFactory)
	.name;
